// extracted by mini-css-extract-plugin
export default {"badge":"badge_badge__jU5a8","withBackground":"badge_withBackground__kkrWD"};